import React from "react";
import BaseDecorator from "./BaseDecorator";
import ProductOrderFieldDecorator from "./ProductOrderFieldDecorator";
import ProductOrderFieldListOptionDecorator from "./ProductOrderFieldListOptionDecorator";
import ProductOrderFieldPickupPointValueDecorator from "./ProductOrderFieldPickupPointValueDecorator";
import AppSettings from "lib/services/AppSettings";
import ProductPickupPointInfo from "lib/components/ProductPickupPointInfo";

export default class OrderedProductOrderFieldDecorator extends BaseDecorator {
  constructor(data) {
    super({
      ...data,
      product_order_field: new ProductOrderFieldDecorator(data.product_order_field),
      value:
        data.product_order_field.type === "ProductOrderField::List"
          ? (data.value_obj || data.value) && new ProductOrderFieldListOptionDecorator(data.value_obj || data.value)
          : data.product_order_field.type === "ProductOrderField::PickupPoint"
          ? (data.value_obj || data.value) &&
            new ProductOrderFieldPickupPointValueDecorator(data.value_obj || data.value)
          : data.value,
    });
  }

  calculateQuantityAndPricing(relatedOrder) {
    this._related_order = relatedOrder;

    this.quantity = this._quantity;
    this.unit_price = this._unit_price;
    this.unit_quantity = this._unit_quantity;
    this.price = this._price;

    delete this._related_order;
  }

  get full_display_name() {
    if (!this.filled_in) {
      return null;
    }

    return [this.display_name, this.display_value].filter((x) => !!x).join(": ");
  }

  get display_name() {
    if (!this.filled_in) {
      return null;
    }

    return this.product_order_field.frontend_name;
  }

  get display_value() {
    if (!this.filled_in) {
      return null;
    }

    switch (this.product_order_field.type) {
      case "ProductOrderField::Boolean":
        return this.value ? I18n.t("base.yes") : I18n.t("base.no");
      case "ProductOrderField::List":
      case "ProductOrderField::Geopoint":
        return this.value ? this.value.name : null;
      case "ProductOrderField::PickupPoint":
        if (this.value) {
          if (this.value.pickup_point_option.pickup_point_type == "predefined") {
            return <ProductPickupPointInfo point={this.value.pickup_point_option.product_pickup_point} />;
          } else {
            return this.value.name;
          }
        } else {
          return null;
        }
      case "ProductOrderField::Country":
        let c = this.value && AppSettings.countries.find((c) => c[0] === this.value);
        return c ? c[1] : null;
      default:
        return this.value;
    }
  }

  get filled_in() {
    return !!this.product_order_field && !!this.value;
  }

  get order_item_name() {
    if (!this.filled_in) {
      return null;
    }

    switch (this.product_order_field.type) {
      case "ProductOrderField::Boolean":
        return this.product_order_field.name;
      case "ProductOrderField::List":
      case "ProductOrderField::Geopoint":
      case "ProductOrderField::PickupPoint":
        return `${this.product_order_field.name}: ${this.value.name}`;
      default:
        return `${this.product_order_field.name}: ${this.display_value}`;
    }
  }

  get _quantity() {
    if (!this._related_order) {
      console.error("this._related_order has to be set in order to use OrderedProductOrderFieldDecorator#quantity");
      return;
    }

    if (!this.filled_in) {
      return 0;
    }

    let quantity;
    switch (this.product_order_field.price_type) {
      case "price_per_order":
        quantity = 1;
        break;
      case "price_per_item":
        if (this.product_order_field.assignation_type === "assignation_per_order") {
          quantity = this._related_order.product_quantity;
          // # } else if (this.product_order_field.assignation_type === "assignation_per_item") {
          // #   quantity = this.ordered_product_pricelist_item.quantity
        }
        break;
      case "price_per_person":
        if (this.product_order_field.assignation_type === "assignation_per_order") {
          quantity = this._related_order.persons_count;
          // # } else if (this.product_order_field.assignation_type === "assignation_per_item") {
          // #   this.ordered_product_pricelist_item.persons_count
        } else if (this.product_order_field.assignation_type === "assignation_per_person") {
          quantity = 1;
        }
        break;
    }

    if (this.product_order_field.multiply_price_by_nights_count && this._related_order.nights_count) {
      quantity *= this._related_order.nights_count;
    }

    return quantity;
  }

  get _unit_quantity() {
    if (!this.filled_in) {
      return 0;
    }

    if (this.product_order_field.type == "ProductOrderField::Number") {
      return this.value;
    } else if (this.value === null) {
      return 0;
    } else {
      return 1;
    }
  }

  get _unit_price() {
    if (!this.product_order_field.has_pricing) {
      return null;
    }

    switch (this.product_order_field.type) {
      case "ProductOrderField::Boolean":
      case "ProductOrderField::Number":
        return this.product_order_field.price;
      case "ProductOrderField::List":
      case "ProductOrderField::PickupPoint":
        return this.value ? this.value.price : null;
    }
  }

  get _price() {
    if (!this.filled_in || !this.product_order_field.has_pricing || !this._unit_price) {
      return null;
    }

    return {
      value: this._unit_price.value * this._unit_quantity * this._quantity,
      currency: this._unit_price.currency,
    };
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/OrderedProductOrderFieldDecorator.js